module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av78-17859338c384a28d96b1dc09ee3c93d1.jpg";